
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import ImageUploadModal from '../media/ImageUploadModal';
// import NativeCameraCapture from '../media/NativeCameraCapture';
// import AppFooter from '../AppFooter';
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaList, FaArrowLeft } from 'react-icons/fa';

// function MemberAdd() {
//   const [email, setEmail] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [address1, setAddress1] = useState('');
//   const [address2, setAddress2] = useState('');
//   const [city, setCity] = useState('');
//   const [state, setState] = useState('');
//   const [zip, setZip] = useState('');
//   const [phone, setPhone] = useState('');
//   const [registerStatus, setRegisterStatus] = useState('');
//   const [waiverUrl, setWaiverUrl] = useState('');
  
//   // Image/video state
//   const [imagePath, setImagePath] = useState(null);          // preview URL (camera or picker)
//   const [cameraMediaUrl, setCameraMediaUrl] = useState(null); // URL returned by server after camera upload
//   const [showNativeCamera, setShowNativeCamera] = useState(false); // Updated for native camera
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);     // from ImageUploadModal
//   const [uploading, setUploading] = useState(false);          // Track upload status

//   const navigate = useNavigate();
//   const tenant = useParams().tenant || localStorage.getItem('tenantId');
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   // Fetch waiver URL on component mount
//   useEffect(() => {
//     const fetchWaiverUrl = async () => {
//       try {
//         const response = await axios.get('/api/tenant-waiver');
//         setWaiverUrl(response.data.waiver || '');
//       } catch (error) {
//         console.error('Error fetching waiver URL:', error);
//       }
//     };
//     fetchWaiverUrl();
//   }, [tenant]);

//   /**
//    * Handle file upload from ImageUploadModal
//    * This allows users to select files from their device
//    */
//   const handleUploadComplete = (files) => {
//     if (files.length > 0) {
//       setSelectedFile(files[0]);
//       setImagePath(URL.createObjectURL(files[0]));
//       setCameraMediaUrl(null); // prefer the newly picked file
//     }
//     setIsImageModalOpen(false);
//   };

//   /**
//    * NEW: Handle native camera capture
//    * This is called when user captures media using the native camera
//    * @param {File[]} capturedFiles - Array of File objects from NativeCameraCapture
//    */
//   const handleNativeCameraCapture = async (capturedFiles) => {
//     console.log('📸 Captured files from native camera:', capturedFiles);
    
//     // Close the camera modal
//     setShowNativeCamera(false);
    
//     if (!capturedFiles || capturedFiles.length === 0) {
//       console.log('No files captured');
//       return;
//     }

//     try {
//       setUploading(true);
      
//       // Upload the captured file(s) - we'll use the first one for member profile
//       const fileToUpload = capturedFiles[0];
      
//       const formData = new FormData();
//       formData.append('file', fileToUpload, fileToUpload.name);

//       console.log('📤 Uploading captured file to member endpoint:', fileToUpload.name);

//       // Upload using existing member upload endpoint
//       const uploadResponse = await axios.post(
//         `${baseUrl}/api/${tenant}/uploadmember`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           withCredentials: true
//         }
//       );

//       console.log('✅ Upload response:', uploadResponse.data);

//       if (uploadResponse.data?.success) {
//         // Get the URL from the response
//         const uploadedUrl = 
//           uploadResponse.data.url || 
//           (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
//         if (uploadedUrl) {
//           // Store the server URL for registration
//           setCameraMediaUrl(uploadedUrl);
//           // Set preview (use uploaded URL or create blob URL)
//           setImagePath(uploadedUrl);
//           // Clear any previously selected file from modal
//           setSelectedFile(null);
          
//           console.log('✅ Media uploaded successfully:', uploadedUrl);
//         } else {
//           console.error('Upload succeeded but no URL returned');
//           alert('Upload completed but image URL not found');
//         }
//       } else {
//         throw new Error(uploadResponse.data?.message || 'Upload failed');
//       }
//     } catch (error) {
//       console.error('❌ Upload failed:', error);
      
//       const errorMessage = 
//         error?.response?.data?.message || 
//         error?.message || 
//         'Failed to upload captured media';
      
//       alert(errorMessage);
//       setRegisterStatus(errorMessage);
//     } finally {
//       setUploading(false);
//     }
//   };

//   /**
//    * Handle member registration
//    * This uploads any selected files and registers the member
//    */
//   const registerMember = async (e) => {
//     e.preventDefault();
//     setRegisterStatus('');

//     // Start with camera media URL if available
//     let uploadedImageUrl = cameraMediaUrl || null;

//     // If user chose an image via modal (and hasn't used camera), upload it now
//     if (selectedFile && !cameraMediaUrl) {
//       const formData = new FormData();
//       formData.append('file', selectedFile);
      
//       try {
//         setUploading(true);
//         const uploadResponse = await axios.post(
//           `${baseUrl}/api/${tenant}/uploadmember`,
//           formData,
//           { 
//             headers: { 'Content-Type': 'multipart/form-data' }, 
//             withCredentials: true 
//           }
//         );
        
//         if (uploadResponse.data?.success) {
//           uploadedImageUrl =
//             uploadResponse.data.url ||
//             (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
//         }
//       } catch (error) {
//         console.warn('Image upload failed, proceeding without an image.', error);
//         setRegisterStatus('Image upload failed, but continuing with registration.');
//       } finally {
//         setUploading(false);
//       }
//     }

//     // Proceed with member registration
//     try {
//       const response = await axios.post(
//         `${baseUrl}/api/members/${tenant}/registermember`,
//         {
//           email,
//           firstname: firstName,
//           lastname: lastName,
//           address1,
//           address2,
//           city,
//           state,
//           zip,
//           phone,
//           image: uploadedImageUrl || null, // can be null
//         },
//         { withCredentials: true }
//       );

//       if (response.data?.success) {
//         // Navigate to members list on success
//         navigate(`/${tenant}/members`);
//       } else {
//         console.error('Registration failed:', response.data?.message);
//         setRegisterStatus(response.data?.message || 'Registration failed.');
//       }
//     } catch (error) {
//       console.error('Error registering member:', error);
//       setRegisterStatus('Error registering member. Please try again.');
//     }
//   };

//   const handleCancel = () => navigate(`/${tenant}/members`);

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Create Account</h2>
      
//       {/* Show upload progress indicator */}
//       {uploading && (
//         <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
//           📤 Uploading media...
//         </div>
//       )}

//       <form onSubmit={registerMember}>
//         <div className="form-group">
//           <label htmlFor="firstName">First Name:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="firstName" 
//             name="firstName"
//             value={firstName} 
//             onChange={(e) => setFirstName(e.target.value)}
//             placeholder="First Name" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="lastName">Last Name:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="lastName" 
//             name="lastName"
//             value={lastName} 
//             onChange={(e) => setLastName(e.target.value)}
//             placeholder="Last Name" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="address1">Address 1:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="address1" 
//             name="address1"
//             value={address1} 
//             onChange={(e) => setAddress1(e.target.value)}
//             placeholder="Address 1" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="address2">Address 2:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="address2" 
//             name="address2"
//             value={address2} 
//             onChange={(e) => setAddress2(e.target.value)}
//             placeholder="Address 2" 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="city">City:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="city" 
//             name="city"
//             value={city} 
//             onChange={(e) => setCity(e.target.value)}
//             placeholder="City" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="state">State:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="state" 
//             name="state"
//             value={state} 
//             onChange={(e) => setState(e.target.value)}
//             placeholder="State" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="zip">Zip:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="zip" 
//             name="zip"
//             value={zip} 
//             onChange={(e) => setZip(e.target.value)}
//             placeholder="Zip" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="email">Email Address:</label>
//           <input 
//             type="email" 
//             className="form-control" 
//             id="email" 
//             name="email"
//             value={email} 
//             onChange={(e) => setEmail(e.target.value)}
//             placeholder="Enter your Email Address" 
//             required 
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="phone">Phone:</label>
//           <input 
//             type="text" 
//             className="form-control" 
//             id="phone" 
//             name="phone"
//             value={phone} 
//             onChange={(e) => setPhone(e.target.value)}
//             placeholder="Enter your Phone Number" 
//             required 
//           />
//         </div>

//         {/* Image/Video Preview */}
//         {imagePath && (
//           <div className="form-group">
//             <label>Preview:</label>
//             <div 
//               className="preview-container" 
//               style={{ 
//                 display: 'flex', 
//                 flexWrap: 'wrap', 
//                 marginTop: 10,
//                 gap: 10
//               }}
//             >
//               {/* Check if it's a video or image based on file type or URL */}
//               {selectedFile?.type?.startsWith('video/') || 
//                imagePath.includes('.mp4') || 
//                imagePath.includes('.mov') || 
//                imagePath.includes('.webm') ? (
//                 <video 
//                   src={imagePath} 
//                   controls
//                   playsInline
//                   style={{ 
//                     width: 200, 
//                     height: 200, 
//                     objectFit: 'cover',
//                     borderRadius: 8 
//                   }} 
//                 />
//               ) : (
//                 <img 
//                   src={imagePath} 
//                   alt="Preview" 
//                   style={{ 
//                     width: 200, 
//                     height: 200, 
//                     objectFit: 'cover',
//                     borderRadius: 8 
//                   }} 
//                 />
//               )}
//             </div>
//           </div>
//         )}
//       </form>

//       {/* Registration status message */}
//       {registerStatus && (
//         <p className="status-message" style={{ 
//           marginTop: '1rem',
//           padding: '0.75rem',
//           backgroundColor: registerStatus.includes('Error') || registerStatus.includes('failed') 
//             ? '#fee' 
//             : '#efe',
//           borderRadius: 4
//         }}>
//           {registerStatus}
//         </p>
//       )}

//       {/* Native Camera Capture Modal */}
//       {showNativeCamera && (
//         <NativeCameraCapture
//           mode="photo"              // Only photos for member profiles
//           multiple={false}          // Single capture only
//           maxFiles={1}              // Only one file needed
//           maxImageSizeMB={10}       // 10MB max for images
//           maxVideoSizeMB={50}       // 50MB max for videos (if mode is changed to 'both')
//           onCapture={handleNativeCameraCapture}
//           onClose={() => setShowNativeCamera(false)}
//         />
//       )}

//       {/* Image Upload Modal (existing functionality preserved) */}
//       {isImageModalOpen && (
//         <ImageUploadModal
//           tenantId={tenant}
//           imageName={`${Date.now()}_${tenant}_${firstName}${lastName}`}
//           onUploadComplete={handleUploadComplete}
//           onClose={() => setIsImageModalOpen(false)}
//         />
//       )}

//       {/* Footer Buttons */}
//       <AppFooter
//         buttons={[
//           { 
//             icon: <FaArrowLeft />, 
//             label: 'Cancel', 
//             onClick: () => navigate(-1),
//             disabled: uploading
//           },
//           { 
//             icon: <FaList />, 
//             label: 'Members', 
//             onClick: handleCancel,
//             disabled: uploading
//           },
//           { 
//             icon: <FaCamera />, 
//             label: 'Take Photo', 
//             onClick: () => setShowNativeCamera(true), 
//             disabled: uploading 
//           },
//           { 
//             icon: <FaUpload />, 
//             label: 'Upload Photo', 
//             onClick: () => setIsImageModalOpen(true), 
//             disabled: uploading 
//           },
//           { 
//             icon: <FaPlus />, 
//             label: 'Create', 
//             onClick: registerMember, 
//             type: 'submit',
//             disabled: uploading
//           },
//         ]}
//       />
//     </div>
//   );
// }

// export default MemberAdd;


import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import ImageUploadModal from '../media/ImageUploadModal';
import NativeCameraCapture from '../media/NativeCameraCapture';
import AppFooter from '../AppFooter';
import { FaCamera, FaUpload, FaPlus, FaList, FaArrowLeft } from 'react-icons/fa';

function MemberAdd() {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [phone, setPhone] = useState('');
  const [registerStatus, setRegisterStatus] = useState('');
  const [waiverUrl, setWaiverUrl] = useState('');
  
  // Image/video state
  const [imagePath, setImagePath] = useState(null);
  const [cameraMediaUrl, setCameraMediaUrl] = useState(null);
  const [showNativeCamera, setShowNativeCamera] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const tenant = useParams().tenant || localStorage.getItem('tenantId');
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  // Fetch waiver URL on component mount
  useEffect(() => {
    const fetchWaiverUrl = async () => {
      try {
        const response = await axios.get('/api/tenant-waiver');
        setWaiverUrl(response.data.waiver || '');
      } catch (error) {
        console.error('Error fetching waiver URL:', error);
      }
    };
    fetchWaiverUrl();
  }, [tenant]);

  /**
   * Handle file upload from ImageUploadModal
   */
  const handleUploadComplete = (files) => {
    if (files.length > 0) {
      setSelectedFile(files[0]);
      setImagePath(URL.createObjectURL(files[0]));
      setCameraMediaUrl(null);
    }
    setIsImageModalOpen(false);
  };

  /**
   * Handle native camera capture
   * @param {File[]} capturedFiles - Array of File objects from NativeCameraCapture
   */
  const handleNativeCameraCapture = async (capturedFiles) => {
    console.log('📸 Captured files from native camera:', capturedFiles);
    
    setShowNativeCamera(false);
    
    if (!capturedFiles || capturedFiles.length === 0) {
      console.log('No files captured');
      return;
    }

    try {
      setUploading(true);
      
      const fileToUpload = capturedFiles[0];
      
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);

      console.log('📤 Uploading captured file to member endpoint:', fileToUpload.name);

      const uploadResponse = await axios.post(
        `${baseUrl}/api/${tenant}/uploadmember`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );

      console.log('✅ Upload response:', uploadResponse.data);

      if (uploadResponse.data?.success) {
        const uploadedUrl = 
          uploadResponse.data.url || 
          (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
        if (uploadedUrl) {
          setCameraMediaUrl(uploadedUrl);
          setImagePath(uploadedUrl);
          setSelectedFile(null);
          console.log('✅ Media uploaded successfully:', uploadedUrl);
        } else {
          console.error('Upload succeeded but no URL returned');
          alert(t('members.updateError'));
        }
      } else {
        throw new Error(uploadResponse.data?.message || t('members.updateFailed'));
      }
    } catch (error) {
      console.error('❌ Upload failed:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.message || 
        t('members.registerError');
      
      alert(errorMessage);
      setRegisterStatus(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  /**
   * Handle member registration
   */
  const registerMember = async (e) => {
    if (e) e.preventDefault();
    setRegisterStatus('');

    let uploadedImageUrl = cameraMediaUrl || null;

    if (selectedFile && !cameraMediaUrl) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      
      try {
        setUploading(true);
        const uploadResponse = await axios.post(
          `${baseUrl}/api/${tenant}/uploadmember`,
          formData,
          { 
            headers: { 'Content-Type': 'multipart/form-data' }, 
            withCredentials: true 
          }
        );
        
        if (uploadResponse.data?.success) {
          uploadedImageUrl =
            uploadResponse.data.url ||
            (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        }
      } catch (error) {
        console.warn('Image upload failed, proceeding without an image.', error);
        setRegisterStatus(t('members.imageUploadFailed'));
      } finally {
        setUploading(false);
      }
    }

    try {
      const response = await axios.post(
        `${baseUrl}/api/members/${tenant}/registermember`,
        {
          email,
          firstname: firstName,
          lastname: lastName,
          address1,
          address2,
          city,
          state,
          zip,
          phone,
          image: uploadedImageUrl || null,
        },
        { withCredentials: true }
      );

      if (response.data?.success) {
        navigate(`/${tenant}/members`);
      } else {
        console.error('Registration failed:', response.data?.message);
        setRegisterStatus(response.data?.message || t('members.registerFailed'));
      }
    } catch (error) {
      console.error('Error registering member:', error);
      setRegisterStatus(t('members.registerError'));
    }
  };

  const handleCancel = () => navigate(`/${tenant}/members`);

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">{t('members.createAccount')}</h2>
      
      {/* Show upload progress indicator */}
      {uploading && (
        <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
          📤 {t('members.uploadingMedia')}
        </div>
      )}

      <form onSubmit={registerMember}>
        <div className="form-group">
          <label htmlFor="firstName">{t('members.firstName')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="firstName" 
            name="firstName"
            value={firstName} 
            onChange={(e) => setFirstName(e.target.value)}
            placeholder={t('members.firstName')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastName">{t('members.lastName')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="lastName" 
            name="lastName"
            value={lastName} 
            onChange={(e) => setLastName(e.target.value)}
            placeholder={t('members.lastName')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="address1">{t('members.address1')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="address1" 
            name="address1"
            value={address1} 
            onChange={(e) => setAddress1(e.target.value)}
            placeholder={t('members.address1')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="address2">{t('members.address2')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="address2" 
            name="address2"
            value={address2} 
            onChange={(e) => setAddress2(e.target.value)}
            placeholder={t('members.address2')}
          />
        </div>

        <div className="form-group">
          <label htmlFor="city">{t('members.city')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="city" 
            name="city"
            value={city} 
            onChange={(e) => setCity(e.target.value)}
            placeholder={t('members.city')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="state">{t('members.state')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="state" 
            name="state"
            value={state} 
            onChange={(e) => setState(e.target.value)}
            placeholder={t('members.state')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="zip">{t('members.zip')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="zip" 
            name="zip"
            value={zip} 
            onChange={(e) => setZip(e.target.value)}
            placeholder={t('members.zip')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">{t('members.email')}:</label>
          <input 
            type="email" 
            className="form-control" 
            id="email" 
            name="email"
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('members.email')}
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">{t('members.phone')}:</label>
          <input 
            type="text" 
            className="form-control" 
            id="phone" 
            name="phone"
            value={phone} 
            onChange={(e) => setPhone(e.target.value)}
            placeholder={t('members.phone')}
            required 
          />
        </div>

        {/* Image/Video Preview */}
        {imagePath && (
          <div className="form-group">
            <label>{t('members.preview')}:</label>
            <div 
              className="preview-container" 
              style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                marginTop: 10,
                gap: 10
              }}
            >
              {selectedFile?.type?.startsWith('video/') || 
               imagePath.includes('.mp4') || 
               imagePath.includes('.mov') || 
               imagePath.includes('.webm') ? (
                <video 
                  src={imagePath} 
                  controls
                  playsInline
                  style={{ 
                    width: 200, 
                    height: 200, 
                    objectFit: 'cover',
                    borderRadius: 8 
                  }} 
                />
              ) : (
                <img 
                  src={imagePath} 
                  alt={t('members.preview')}
                  style={{ 
                    width: 200, 
                    height: 200, 
                    objectFit: 'cover',
                    borderRadius: 8 
                  }} 
                />
              )}
            </div>
          </div>
        )}
      </form>

      {/* Registration status message */}
      {registerStatus && (
        <p className="status-message" style={{ 
          marginTop: '1rem',
          padding: '0.75rem',
          backgroundColor: registerStatus.includes('Error') || registerStatus.includes('failed') 
            ? '#fee' 
            : '#efe',
          borderRadius: 4
        }}>
          {registerStatus}
        </p>
      )}

      {/* Native Camera Capture Modal */}
      {showNativeCamera && (
        <NativeCameraCapture
          mode="photo"
          multiple={false}
          maxFiles={1}
          maxImageSizeMB={10}
          maxVideoSizeMB={50}
          onCapture={handleNativeCameraCapture}
          onClose={() => setShowNativeCamera(false)}
        />
      )}

      {/* Image Upload Modal */}
      {isImageModalOpen && (
        <ImageUploadModal
          tenantId={tenant}
          imageName={`${Date.now()}_${tenant}_${firstName}${lastName}`}
          onUploadComplete={handleUploadComplete}
          onClose={() => setIsImageModalOpen(false)}
        />
      )}

      {/* Footer Buttons */}
      <AppFooter
        buttons={[
          { 
            icon: <FaArrowLeft />, 
            label: t('common.cancel'),
            onClick: () => navigate(-1),
            disabled: uploading
          },
          { 
            icon: <FaList />, 
            label: t('members.members'),
            onClick: handleCancel,
            disabled: uploading
          },
          { 
            icon: <FaCamera />, 
            label: t('members.takePhoto'),
            onClick: () => setShowNativeCamera(true), 
            disabled: uploading 
          },
          { 
            icon: <FaUpload />, 
            label: t('members.uploadPhoto'),
            onClick: () => setIsImageModalOpen(true), 
            disabled: uploading 
          },
          { 
            icon: <FaPlus />, 
            label: t('members.createAccount'),
            onClick: registerMember, 
            type: 'submit',
            disabled: uploading
          },
        ]}
      />
    </div>
  );
}

export default MemberAdd;